import { Box } from '@mantine/core'
import { Navigate, Outlet } from 'react-router-dom'

import { FullPageSpinner } from '../common/components/FullPageSpinner/FullPageSpinner'

import { useAuth } from '@percent/workplace-giving/common/hooks/useAuth/useAuth'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'

export function AllowUnauthenticatedAccountOnlyRoute() {
  const { state } = useAuth()

  if (state.status === 'loading' || state.status === 'first_load') {
    return <FullPageSpinner />
  }

  if (state.status === 'unauthorized') {
    return (
      <Box
        style={{
          '*': {
            fontFamily: 'Inter, sans-serif'
          }
        }}
        data-testid="unauthorized"
      >
        <Outlet />
      </Box>
    )
  }

  return <Navigate to={AppRoute.HOME} />
}
